export default __webpack_public_path__ + "static/media/mainBgCollectionMobile.12581f3c.svg";